import { atom } from 'recoil';

//* 전화 응대 중 찾은 이전 주문에서 가져온 주문자 정보·문구.
//* 부고 조회 페이지에서 담아두면 전화주문생성 모달의 정보 입력 단계에서 그대로 채워진다.
export type SellerCallOrderPrefill = {
  senderName: string;
  senderPhoneNumber: string;
  senderPhrase: string;
  condolencePhrase: string;
  //* 어떤 주문에서 가져왔는지 (배너 표기용)
  sourceLabel: string;
};

export const sellerCallOrderPrefillAtom = atom<SellerCallOrderPrefill | null>({
  key: 'sellerCallOrderPrefillAtom',
  default: null,
});
